




















































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import GroupActivitySection from '@/components/groupType/index/GroupActivitySection.vue';
import { Getter, Action } from 'vuex-class';
import CourseGroupingList from './CourseGroupingList.vue';
import getUrlParam from '@/common/utils/getUrlParam';
import fetch from '@/common/api/fetch';
import { exchangeMsgToXcx, wechatSignUp } from '@/common/utils/wechatFunc';
import { AxiosPromiseData, AxiosPromiseError, ShareObjectInterface, SignatureData } from '@/common/interface';
import CourseDetailIntroList from '@/components/common/index/CourseDetailIntroList.vue';
import CONFIG from '@/common/config';
import { pickHtmlTextContent } from '@/common/utils/dealWithString';

const loadingImage = require('@/assets/img/loadingImage.gif');
@Component({
  components: {
    'group-activity-section': GroupActivitySection,
    'course-grouping-list': CourseGroupingList,
    'coruse-intro-list': CourseDetailIntroList
  }
})
export default class CourseGroup extends Vue {
  @Getter('section') section!: any;
  @Getter('urlUid') urlUid!: string;
  @Getter('uid') uid!: string;
  @Getter('startTime') startTime!: number;
  @Getter('deadline') deadline!: string;

  @Getter('courseGroupList') courseGroupList!: any;
  @Getter('unGroupSwitch') unGroupSwitch!: boolean;
  @Getter('courseType') courseType!: string;
  @Getter('canPay') canPay!: boolean;
  @Getter('openId') openId!: string;
  @Getter('orgId') orgId!: string;
  @Getter('joinNumber') joinNumber!: number;
  @Getter('posterName') posterName!: string;
  @Getter('hasPay') hasPay!: number;
  @Getter('qrCodeUrl') qrCodeUrl!: string;
  @Getter('title') title!: string;
  @Getter('coverTiny') coverTiny!: string;
  @Getter('signature') signature!: SignatureData;
  @Getter('cancel') cancel!: boolean;

  @Action('changeUid') changeUid!: Function;
  @Action('changeLeadersInstId') changeLeadersInstId!: Function;
  @Action('changeJoinNumber') changeJoinNumber!: Function;
  @Action('changeUrlUid') changeUrlUid!: Function;
  @Action('changePosterUrl') changePosterUrl!: Function;

  introsVisible: boolean = false;
  originatorId: string = '';
  loadingImage: string = loadingImage;
  showCourseItem: any = {};

  getCourseIntroStr(list: any) {
    console.log(this.courseGroupList);

    let str = '';
    for (let i = 0; i < list.length; i++) {
      if (list[i].type === 'text') {
        str = list[i].value;
        // 去掉html字符串中的所有标签元素
        return str.replace(/<[^>]+>/g, '');
      }
    }
    return '';
  }
  // 获取拼团价的整数和小数
  getCurrentPriceStr(list: any, k: number = 0) {
    const currentPrice = list[list.length - 1].groupPrice;
    const currentPriceStr = currentPrice.toString().split('.');
    return currentPriceStr[k];
  }
  // 获取拼团价的人数
  getGroupSizeStr(list: any) {
    const size = list[list.length - 1].groupSize;
    return size;
  }
  getNumberStr(seqNo: number) {
    const arr = ['一', '二', '三', '四', '五', '六'];
    return arr[seqNo - 1];
  }
  openDetailModal(item: any = {}) {
    if (
      item.courseIntros.length === 0 ||
      (item.courseIntros.length === 1 && item.courseIntros[0].type === 'text' && !this.getCourseIntroStr(item.courseIntros))
    ) {
      return;
    }
    this.showCourseItem = item;
    this.introsVisible = true;
  }
  closeDetailModal() {
    this.introsVisible = false;
  }
  handleVideo(item: any) {
    fetch.parseUrl(item.value).then((res: any) => {
      const query = {
        url: res || item.value
      };
      this.$router.push({
        name: 'video',
        query: query
      });
    });
  }
  // 开团-弹窗
  handleShowOpenModal(seqNo: number) {
    // 活动未开始
    if (new Date().valueOf() < this.startTime) {
      Vue.$toast.error('活动未开始');
      return;
    }
    // 如果活动已过期，则弹窗
    if (new Date().valueOf() > Number(this.deadline)) {
      Vue.$confirm({
        oneBtn: true,
        title: '来晚啦',
        text: '活动已结束！',
        okText: '确定'
      });
      return;
    }
    // 活动未发布
    if (getUrlParam('type') === 'check') {
      return;
    }

    this.changeLeadersInstId('');

    if (this.canPay) {
      // 未报名或者已经报名但是没有支付
      const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
      const host: string = location.host;
      const tempStr: string = env === 'gray' ? '/xmpay' : '/xmpay';
      if (!this.uid || (this.uid && this.hasPay !== 4)) {
        // 跳转到小程序支付页面
        if (window.__wxjs_environment === 'miniprogram') {
          const promoterId = getUrlParam('promoterId');
          const referralId = getUrlParam('referralId');
          const broadcastId = getUrlParam('broadcastId');
          let qrCodeUrl = this.qrCodeUrl;
          if (env === 'gray') {
            qrCodeUrl = qrCodeUrl.replace('xmshow', 'xmshow/gray');
          }
          const scene =
            `openId=${this.openId}&activityId=${broadcastId}&qrCodeUrl=${encodeURIComponent(qrCodeUrl)}` +
            (promoterId ? `&promoterId=${promoterId}` : '') +
            (referralId ? `&referralId=${referralId}` : '') +
            (this.urlUid ? `&parentUid=${this.urlUid}` : '') +
            (seqNo ? `&seqNo=${seqNo}` : '');
          window.wx.miniProgram.redirectTo({
            url: `/pages/pay-detail/index?${scene}`
          });
        } else {
          fetch.post('c/common/pay/appid', {}).then((res: AxiosPromiseData) => {
            const payAppId: string = res.data;
            const targetUrl: string =
              'https://' +
              host +
              tempStr +
              (env === 'prod' || env === 'gray' ? '/index.html' : '/') +
              '#/xmx_group_pay?userOpenId=' +
              this.openId +
              '&broadcastId=' +
              getUrlParam('broadcastId') +
              (getUrlParam('promoterId') ? '&promoterId=' + getUrlParam('promoterId') : '') +
              (getUrlParam('referralId') ? '&referralId=' + getUrlParam('referralId') : '') +
              (this.urlUid ? '&parentUid=' + this.urlUid : '');
            const url: string =
              (CONFIG.shareUrl as any)[env] +
              payAppId +
              '&redirect_uri=' +
              encodeURIComponent(targetUrl) +
              (targetUrl.indexOf('?') != -1 ? '%26' : '%3F') +
              'appid%3D' +
              payAppId +
              '&response_type=code&scope=snsapi_base&state=state#wechat_redirect';
            location.href = url;
          });
        }
      } else {
        // 已报名,跳转到小程序支付结结果页面
        if (window.__wxjs_environment === 'miniprogram') {
          const broadcastId = getUrlParam('broadcastId');
          let qrCodeUrl = this.qrCodeUrl;
          if (env === 'gray') {
            qrCodeUrl = qrCodeUrl.replace('xmshow', 'xmshow/gray');
          }
          const scene = `openId=${this.openId}&activityId=${broadcastId}&qrCodeUrl=${encodeURIComponent(qrCodeUrl)}`;
          window.wx.miniProgram.redirectTo({
            url: `/pages/pay-result/index?${scene}`
          });
        } else {
          const targetUrl: string =
            'https://' +
            host +
            tempStr +
            (env === 'prod' || env === 'gray' ? '/index.html' : '/') +
            '#/xmx_group_pay_result?userOpenId=' +
            this.openId +
            '&broadcastId=' +
            getUrlParam('broadcastId');
          location.href = targetUrl;
        }
      }
    } else {
      Vue.$modal({
        seqNo: seqNo,
        ok: (name: string, phone: string, authCode: string, additionalInfo: string, instId?: string, seqNo?: number) => {
          const query = {
            name,
            phone,
            authCode,
            additionalInfo,
            instId,
            seqNo
          };
          this.openGroup(query);
        }
      });
    }
  }
  // 开团
  openGroup(query: any) {
    const { name, phone, authCode, additionalInfo, instId, seqNo } = query;
    if (this.orgId && !instId) {
      Vue.$toast.error('请选择校区');
      return null;
    }
    const data = {
      name,
      instId,
      phone,
      authCode,
      additionalInfo,
      openId: this.openId,
      activityId: getUrlParam('broadcastId')
    };
    const promoterId: string = getUrlParam('promoterId') as string;
    const referralId: string = getUrlParam('referralId') as string;
    if (promoterId) {
      (data as any).promoterId = promoterId;
    }
    if (referralId) {
      (data as any).referralId = referralId;
    }

    (data as any).seqNo = seqNo || 1;

    console.log('开团-data', data);
    fetch
      .newpost('anon/group/joinActivity', data)
      .then((res: AxiosPromiseData) => {
        // this.show = false;
        const { result } = res;

        Vue.$confirm({
          title: '提示',
          text: '您已成功报名，<br />快去找好友一起拼团吧！',
          cancleText: '我知道了',
          okText: '找好友一起拼',
          cancle: () => {
            this.changeUid({ uid: result });
            this.changeJoinNumber(this.joinNumber + 1);
            const location = window.location.href.replace(/[?, &]code.*state/i, '').replace(/&uid=\d*/, '') + '&uid=' + result;
            this.changeUrlUid(result);
            this.signatureWechatShare(location);
            exchangeMsgToXcx(result);
          },
          ok: () => {
            this.changeUid({ uid: result });
            this.changeJoinNumber(this.joinNumber + 1);
            const location = window.location.href.replace(/[?, &]code.*state/i, '').replace(/&uid=\d*/, '') + '&uid=' + result;
            this.changeUrlUid(result);
            this.handleRedirectToSharePage(result);
            this.signatureWechatShare(location);
            exchangeMsgToXcx(result);
          }
        });
      })
      .catch((error: AxiosPromiseError) => {
        if (error.resultCode === 1402) {
          // this.show = false;
          Vue.$confirm({
            oneBtn: true,
            title: '很抱歉',
            text: '活动已结束',
            okText: '确定'
          });
        }
        if (error.resultCode === 1519) {
          // this.show = false;
          Vue.$confirm({
            oneBtn: true,
            title: '很抱歉',
            text: `该活动已达到${this.canPay ? '支付人数' : '成团数'}上限，<br />无法继续开团/参团！`,
            okText: '确定'
          });
        }
      });
  }

  signatureWechatShare(location: string) {
    const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    const shareUrl: string =
      (CONFIG.shareUrl as any)[env] +
      (CONFIG.appId as any)[env] +
      '&redirect_uri=' +
      encodeURIComponent(location) +
      '&response_type=code&scope=snsapi_base&state=state#wechat_redirect';
    const shareObject: ShareObjectInterface = {
      title: this.title.replace(/<br\/>/g, '\n'),
      desc: pickHtmlTextContent(this.section.courseDesc),
      link: shareUrl,
      imgUrl: this.coverTiny
    };
    this.changePosterUrl(shareUrl);
    wechatSignUp(this.signature, shareObject);
  }

  // 显示/隐藏分享popup
  handleRedirectToSharePage(parentUid: string) {
    // 跳转到小程序分享页面
    const broadcastId = getUrlParam('broadcastId');
    const posterName = this.posterName;
    const origin = getUrlParam('origin');
    // 团购分享出去的链接需要带上团长id
    // 如果是从独立版小麦秀小程序进入的分享页,那么分享的时候就跳到独立版小麦秀的分享页
    if (origin === 'ordinary') {
      window.wx.miniProgram.redirectTo({
        url: `/pages/activity/activityShare/main?id=${broadcastId}&parentUid=${parentUid}`
      });
    } else {
      window.wx.miniProgram.redirectTo({
        url: `/pages/user-share/index?broadcastId=${broadcastId}&parentUid=${parentUid}&name=${posterName}`
      });
    }
  }
}
